/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionFilter {
    getFixupPrototypeFunction() { return DimensionDefinitionFilter.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionFilter>): DimensionDefinitionFilter {
        let obj = Object.assign(new DimensionDefinitionFilter(), model);
        DimensionDefinitionFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionFilter>): DimensionDefinitionFilter {
        if (!model) return null;
        return DimensionDefinitionFilter.newInstance(<DimensionDefinitionFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionFilter) {
        if (!obj) return;

        models.DimensionDefinitionFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionFilter): boolean {
        Object.setPrototypeOf(obj, DimensionDefinitionFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Text filter used to search names
     */
    text_filter: string;

    /**
     * Query operator
     */
    query: models.QueryOperator;

}
